
import { useAppDispatch, useAppSelector } from './Redux/store';
import { UIMode } from './Redux/uiSlice';
import { ModalResolver } from './components/ModalResolver';
import { useKeyboardEventListener } from './hooks/keyboardEventListener';
import { useScreenSize } from './hooks/screenSize';
import { useSetStoredGame } from './hooks/setStoredgame';
import { useActionButtons } from './hooks/useActionButtons';
import { usePreventZoom } from './hooks/zoom';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Assets } from './components/Pages/Assets';
import { DeveloperModeUI } from './components/DeveloperModeUI';
import { HandHeld } from './components/main/HandHeld';
import { NotFound } from './components/Pages/NotFound';
import { useEffect } from 'react';
import { InteractionScreen, setScreen } from './Redux/screenInteractionsSlice';
import { Leaderboard } from './components/Pages/Leaderboard';


function App() {
  const dispatch = useAppDispatch();
  const { modal, screen } = useAppSelector(state => ({
    modal: state.ui.modal,
    screen: state.screenInteractions.screen
  }));

  useEffect(() => {
    switch (window.location.pathname) {
      case '/build':
        dispatch(setScreen(InteractionScreen.SANDBOX))
        break;
      case '/':
        dispatch(setScreen(InteractionScreen.WELCOME))
    }
  }, [window.location.pathname])

  useSetStoredGame();
  useKeyboardEventListener([modal, screen]);
  useActionButtons();
  useScreenSize();
  usePreventZoom();

  return (
    <>
      <ModalResolver />
      <Routes>
        <Route
          path="/"
          element={
            <Layout children={
              <div className={`flex items-center sm:items-start relative w-full h-full sm:h-[calc(100%-48px)] justify-center gap-8`}>
                <HandHeld />
              </div>
            }
            />
          }
        />
        <Route
          path="/build"
          element={
            <Layout
              children={
                <>
                  <p className='font-pixel-text text-sm md:hidden h-full items-center flex'>Sorry, not available on small screens... yet!</p>
                  <div className={`hidden md:flex items-center sm:items-start relative w-full h-full sm:h-[calc(100%-48px)] gap-8 px-4`}>
                    <HandHeld />
                    <DeveloperModeUI />
                  </div>
                </>
              }
            />
          }
        />
        <Route
          path="/leaderboard"
          element={
            <Layout children={<Leaderboard />}
            />
          }
        />
        <Route
          path="/assets"
          element={
            <Layout children={<Assets
            />
            }
            />
          }
        />
        <Route
          path="/*"
          element={
            <Layout children={<NotFound
            />
            }
            />
          }
        />
      </Routes>
    </>
  );
}

export default App;
